<template>
  <v-row>
    <v-col cols="6">
      <v-file-input
        show-size
        counter
        v-model="fileUpload"
        accept=".csv"
        label="Seleccione el archivo masivo:"
        clearable
      ></v-file-input>
    </v-col>
    <v-col cols="6">
      <v-file-input
        show-size
        counter
        v-model="fileUploadArchive"
        accept=".pdf,.eml,.msg,.mp3,.wav,.zip,.png,.jpg"
        label="Seleccione el archivo a subir:"
        clearable
      ></v-file-input>
    </v-col>
    <!-- Observaciones -->
    <v-col cols="12" sm="12" md="10">
      <v-text-field
        v-model="Observaciones"
        label="Mensaje:"
        type="text"
        clearable
      ></v-text-field>
    </v-col>
    <!-- Guardar -->
    <v-col cols="2">
      <v-btn
        block
        @click="convertToBase64()"
        text
        dark
        size="x-large"
        color="green"
      >
        <template v-slot:prepend>
          <v-icon>mdi-content-save</v-icon>
        </template>
        Guardar</v-btn
      >
    </v-col>
  </v-row>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "Migracion-Activos",
  data() {
    return {
      progreso: false,
      fileUpload: [],
      fileUploadArchive: [],
      Observaciones: "",
    };
  },

  ///////////////////////////////////////////////// Métodos de Watch ///////////////////////////////////////////
  watch: {
    // Colocar ya que el sistema al ver que la URL ya esta cargada no la vuelve a cargar
    $route: function () {
      var page = this.$store.getters.userperfil.paginainfo;
      var servicioID = 0;
      if (page.param1) {
        servicioID = parseInt(page.param1);
        console.log(servicioID);
      }
    },
  },

  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Envia Archivo Base 64
    async convertToBase64() {
      if (this.fileUpload.length > 0 && this.fileUploadArchive.length > 0) {
        // Archivo Masivo
        const file = this.fileUpload[0]; // Obtener el archivo seleccionado
        console.log(file);
        if (!file) return;

        // Archivo Subido 2
        const file2 = this.fileUploadArchive[0]; // Obtener el archivo seleccionado
        console.log(file2);
        if (!file2) return;

        const buffer = await file.arrayBuffer();
        const bytes = Array.from(new Uint8Array(buffer));

        const buffer2 = await file2.arrayBuffer();
        const bytes2 = Array.from(new Uint8Array(buffer2));

        var userperfil = this.$store.getters.userperfil;
        var page = this.$store.getters.userperfil.paginainfo;
        var servicioID = 0;
        if (page.param1) {
          servicioID = parseInt(page.param1);
        }

        var data = {
          ArchiveMassive: bytes,
          ArchivoCargar: bytes2,
          Observation: this.Observaciones,
          Servicio: servicioID,
          NombreArchivo: file2.name,
          TipoArchivo: file2.type,
          UsuarioLogin: userperfil.userInfo.Usuario_ID,
        };

        this.getPostArvhivoAEP(data); // Enviar la cadena Base64
      } else {
        this.$swal({
          icon: "warning",
          title: "Archivos Incompletos.",
          html: "Por favor, suba los archivos antes de guardar",
        });
      }
    },

    // Envia Archivo masivo
    async getPostArvhivoAEP(data) {
      this.progreso = true;
      this.axios
        .post("/Personas/Id_ComunicacionTrazabilidad/CRMassive", data)
        .then((response) => {
          this.$swal({
            icon: "success",
            title: "Relación Guardada",
            html: "La información se ha guardado correctamente.",
          });
          this.fileUpload = [];
          this.fileUploadArchive = [];
          this.Observaciones = "";
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
  },
  mounted() {},
};
</script>
